<script>
  import {Line} from 'vue-chartjs'

  export default {
    name: "ComparativoPeriodo",
    extends: Line,
    props: {dados:''},

    computed: {
      chartData1() {
        return this.dados.periodo1;
      },
      chartData2() {
        return this.dados.periodo2;
      }
    },

    methods: {
      renderizarGrafico() {
        let data = {
          labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
          datasets: [
            {
              label: 'Mês Atual',
              data: this.chartData1,
              borderColor: "#9454F0",
              backgroundColor:'rgba(148,84,240,0.20)',
              fill: true
            },
            {
              label: 'Mês Anterior',
              data: this.chartData2,
              borderColor: "#F40486",
              backgroundColor: "rgba(244,4,134,0.20)",
              fill: true
            }
          ]
        };

        let options = {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,
              right: 25,
              top: 25,
              bottom: 0
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                maxTicksLimit: 8
              }
            }],
            yAxes: [{
              ticks: {
                maxTicksLimit: 5,
                padding: 10,
                callback: (val) => {
                  return 'R$ ' + val.toFixed()
                }
              },
              gridLines: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false,
                zeroLineBorderDash: [2]
              }
            }]
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: 'index',
            caretPadding: 10,
            callbacks: {
              title: (item) => {
                return 'Dia: ' + item[0].label
              },
              label: (tooltipItem, chart) => {
                const datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                return datasetLabel + ': ' + this.setLabel(tooltipItem.yLabel);
              }
            }
          }
        };

        this.renderChart(data, options)
      },

      setLabel(value) {
        if (value === undefined || value === false) {
          return value;
        }

        value = parseFloat(value);
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2
        });

        return formatter.format(value);
      }
    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>
